"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepContent = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../styles");
var useStepperContext_1 = require("./useStepperContext");
function StepContent(props) {
    var children = props.children, style = props.style, rest = __rest(props, ["children", "style"]);
    var _a = useStepperContext_1.useStepperContext(), direction = _a.direction, gap = _a.gap;
    var _b = styles_1.useStyles(createStyles, direction, gap), classes = _b.classes, css = _b.css;
    return (react_1.default.createElement("div", __assign({ className: css(classes.content, style) }, rest), children));
}
exports.StepContent = StepContent;
var DEFAULT_VERTICAL_PADDING = 1.25; // rem
var createStyles = function (_theme, direction, gap) {
    var isVertical = direction === 'vertical';
    return {
        content: {
            width: '100%',
            padding: DEFAULT_VERTICAL_PADDING + "rem 0.5rem",
            paddingLeft: isVertical && '2rem',
            paddingBottom: getPaddingBottom(direction, gap),
        },
    };
};
var getPaddingBottom = function (direction, gap) {
    if (gap === void 0) { gap = 0; }
    if (direction === 'horizontal' || gap > DEFAULT_VERTICAL_PADDING)
        return '0rem';
    if (gap > 0 && gap <= DEFAULT_VERTICAL_PADDING)
        return DEFAULT_VERTICAL_PADDING - gap + "rem";
    return DEFAULT_VERTICAL_PADDING + "rem";
};
//# sourceMappingURL=StepContent.js.map